export default __webpack_public_path__ + "static/media/raindeximg1.792d0dd6b298450fed1f312572aa320e.png";